import React from "react";
import SendImg from "assets/images/svg/ordered.svg";
import Attach from "assets/images/svg/attach.svg";

import { useForm } from "react-hook-form";
import { useAuthContext } from "store/auth";
import { toBase64 } from "helpers/data";
import { client } from "helpers/client";
import { Ticket, TicketStatus } from "pages/tickets/ticket.service";
import { useMutation } from "react-query";
import CloseIcon from "assets/images/svg/cancel.svg"
import {useTranslation} from "react-i18next";

function MessageInput({ ticket,onAddMessage }: { ticket: Ticket,onAddMessage: (message:any) =>void }) {
  const {t} = useTranslation('tickets');
  const [{ user }] = useAuthContext();
  const isReadonly = ticket?.statusId === TicketStatus.Closed || ticket?.statusId === TicketStatus.Cancelled;
  const { register, handleSubmit, setValue, watch,reset } = useForm();
  const fileRef = React.useRef<HTMLInputElement>(null);
  const attachmentField = register("attachment");
  const attachment: File | undefined = watch("attachment");
  const messageContent: string = watch("messageContent");

  // {
  //   // When mutate is called:
  //   onMutate: async (newTicket: any) => {
  //     await queryClient.cancelQueries(["ticket-messages", ticket.id]);
  //     const previousTickets = queryClient.getQueryData(["ticket-messages", ticket.id]);
  //     queryClient.setQueryData(["ticket-messages", ticket.id], (old: any) => {
  //       const newData = { ...old };
  //       newData.pages[0].messages.unshift({ ...newTicket, isCustomerMessage: true });
  //       console.log(newData)
  //       return newData;
  //     });
  //     return { previousTickets };
  //   }
  // }

  const { mutate: sendMessage, isLoading } = useMutation((messageDto: any) => client("/ticket/sendMessage", { data: messageDto }));

  async function onSubmit() {
    reset({messageContent:"" , attachment:''});
    const messageDto = {
      ticketId: ticket.id,
      senderName: user.Name,
      isCustomerMessage:true,
      message: messageContent,
      hasAttachment: !!attachment,
      attachment: {
        fileName: attachment?.name,
        mimeType: attachment?.type,
        fileBase64: attachment ? await toBase64(attachment) : ""
      }
    };

     await sendMessage(messageDto,{onSuccess:() => onAddMessage(messageDto)});

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="chat-action">
      <textarea {...register("messageContent", { required: true })} readOnly={isReadonly} placeholder={t('type-your-message')} />
      <div className="attachment d-flex">
        {attachment && (
          <div className="uploadImg">
             { /image/.test(attachment.type) &&  <img width={35} src={URL.createObjectURL(attachment)} alt="preview-attachment" />}
            <p>{attachment?.name} </p>
            <button className="btn-icon" onClick={() => setValue("attachment", undefined)}>
              <img width="8" height="8" src={CloseIcon} alt="remove-attachment-icon" />
            </button>
          </div>
        )}
      </div>
      <hr className="hr" />
      <div className="div-btn">
        <div>
          <input
            id="file"
            hidden
            type="file"
            {...attachmentField}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setValue("attachment", e.target.files?.[0]);
              attachmentField.onChange(e);
            }}
            ref={fileRef}
          />
          <button
            className="btn-attach"
            type="button"
            onClick={() => fileRef.current?.click()}
            disabled={isReadonly || !!attachment}
          >
            <img src={Attach} alt="attach" />
          </button>
        </div>
        <div>
          {!isReadonly && <p className="info">{t('shift-enter')}</p>}
          <button disabled={isLoading || (!messageContent && !attachment) || isReadonly} className="btn-send">
            {isLoading ? "Sending..." : <img src={SendImg} alt="send" />}
          </button>
        </div>
      </div>
    </form>
  );
}

export default MessageInput;
